import React, { ReactNode, use } from 'react';
import './ConfirmationPopup.css';
import { useTheme } from '@ohif/ui';
//import { customStyle } from '@custom/Utils/utils';

interface ConfirmationPopupProps {
  title?: string;
  message?: any;
  onConfirm?: () => void;
  onCancel?: () => void;
  isOpen?: boolean;
  textField?: ReactNode;
  deleteMessage?: string;
}

const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({
  title,
  message,
  onConfirm,
  onCancel,
  isOpen,
  textField,
  deleteMessage,
}) => {
  if (!isOpen) return null;
  const { isDarkMode } = useTheme();
  const cancelButtonLabel = textField ? 'Cancel' : 'No';
  const confirmButtonLabel = textField ? 'Submit' : 'Yes';

  return (
    <div className='popup-overlay'>
      <div className='popup-container'>
        {deleteMessage && (
          <p className="popup-para" style={{ color: 'red', fontSize: '14px', textAlign: 'center' }}>
            {deleteMessage}
          </p>
        )}
        {title && <h2 className="mb-5 popup-heading">{title}</h2>}
        {message && <p className="popup-para">{message}</p>}
        {textField && <div className="popup-textfield">{textField}</div>}
        <div className={`popup-actions text-left ${title && 'text-left'}`}>
          <button className="custom-button main-theme" onClick={onConfirm}>
            {confirmButtonLabel}
          </button>
          <button
            className="custom-button"
            style={
              isDarkMode
                ? { color: '#ffffff', borderColor: '#ffffff' }
                : { color: '#000000', borderColor: '#000000' }
            }
            onClick={onCancel}
          >
            {cancelButtonLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPopup;
